// Standard configuration tables for features.
// TODO: These should be contained in their feature modules. I

import { ProfileSize } from "component/people";
import type { Datastore } from "./datastore";
import { declareTable, Persona } from "./stdtypes";

// In here because question is currently special-casing them.
// TODO: Move to feature modules, and stop question special-casing them.
export type Upvote = {
    key: string;
    from: string;
    comment: string;
}
export const upvoteTable = declareTable<Upvote>('upvote');

export type Reaction = {
    key: string;
    from: string;
    reactTo: string;
    reactionType: string;
}
export const reactionTable = declareTable<Reaction>('reaction');

export type StandardConfig = {
    readOnly?: boolean;
    openLinksInNewTab?: boolean;
    topBarHelpBubbles?: React.ComponentType<{}>[];
    sidebarCloseModal?: React.ComponentType<{onDone: () => void}> | null;
    sidebarShouldShowCloseModal?: ((datastore: Datastore) => boolean) | null;
    profilePhotoLayers?: React.ComponentType<{persona: Persona, size: number, type: ProfileSize}>[];
    bylineTags?: ((persona: Persona) => string)[];
}

